'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var nthGrid = require('@narvar/nth-grid');
var styled = _interopDefault(require('styled-components'));

var DT_DEFAULT_GUTTER_HALF_WIDTH = '0.25rem';
var DT_DEFAULT_MAX_WIDTH = '952px';
var _styledBreakpoint = nthGrid.styledBreakpoint()(nthGrid.gridContainer({
    gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH,
    gridContainerMaxWidths: {
      lg: DT_DEFAULT_MAX_WIDTH,
      xl: DT_DEFAULT_MAX_WIDTH
    }
  })(styled.div.withConfig({
    componentId: "sc-1ngwfjo-0"
  })([""]))),
  containerComponent = _styledBreakpoint.component;
var _styledBreakpoint2 = nthGrid.styledBreakpoint()(nthGrid.gridGutterColumn({
    gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH
  })(nthGrid.gridColumnOffset()(nthGrid.gridColumn()(styled.div.withConfig({
    componentId: "sc-1ngwfjo-1"
  })(["min-height:1px;"]))))),
  columnComponent = _styledBreakpoint2.component;
var _styledBreakpoint3 = nthGrid.styledBreakpoint()(nthGrid.gridGutterRow({
    gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH
  })(nthGrid.gridRow()(styled.div.withConfig({
    componentId: "sc-1ngwfjo-2"
  })([""])))),
  rowComponent = _styledBreakpoint3.component;

exports.DT_DEFAULT_MAX_WIDTH = DT_DEFAULT_MAX_WIDTH;
exports.columnComponent = columnComponent;
exports.containerComponent = containerComponent;
exports.rowComponent = rowComponent;
